import React from 'react';

const Skill = ({ name, level }) => {
  return (
    <div className="skill">
      <div className="skill-name">{name}</div>
      <div className="skill-level">{level}</div>
    </div>
  );
};

export default Skill;
